import PropTypes from "prop-types";
import styles from "./index.css";
import content from "app-content";
import classnames from "classnames";
import Banner from "../Banner";
import { INFORMATION } from "../Banner/constants";

const ErrorBanner = ({
  className,
  errorMessage,
  onRetry,
  render,
  showRetryButton
}) => {
  if (!errorMessage) return null;

  const retryButton = () =>
    showRetryButton ? (
      <button onClick={onRetry} className={styles.retry}>
        {content.saved_items_pageload_error_retry}
      </button>
    ) : null;

  return (
    <Banner
      ariaLive="assertive"
      className={classnames(styles.errorBanner, styles.show, className)}
      innerContent={retryButton}
      message={errorMessage}
      outerContent={render}
      iconClass={INFORMATION}
    />
  );
};

ErrorBanner.propTypes = {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  onRetry: PropTypes.func,
  render: PropTypes.func,
  showRetryButton: PropTypes.bool
};

export default ErrorBanner;
